import { useResourceContext } from 'react-admin';
import { useSubscribe } from './useSubscribe';
export var useSubscribeToLocks = function (subscriptionCallback, resource, options) {
    var actualResource = useResourceContext({ resource: resource });
    useSubscribe(resource ? "lock/" + actualResource : null, subscriptionCallback, options);
};
